import { render } from "./NewsListItem.vue?vue&type=template&id=5c8be560&scoped=true"
import script from "./NewsListItem.vue?vue&type=script&lang=js"
export * from "./NewsListItem.vue?vue&type=script&lang=js"

import "./NewsListItem.vue?vue&type=style&index=0&id=5c8be560&scoped=true&lang=css"

import exportComponent from "E:\\workspace\\digital-gate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c8be560"]])

export default __exports__